import { styled } from 'styled-components';
import React, { FC, ReactNode } from 'react';
import { flexGap } from '@/flexGap';
import { Typography } from '@/components/text/Typography';

const List = styled.ol`
  display: flex;
  flex-direction: column;
  ${({ theme }) => flexGap(theme.spacing[2])};
  width: 100%;
`;

const ListItem = styled.li`
  display: flex;
  flex-direction: row;
  ${({ theme }) => flexGap(theme.spacing[1.5])};
`;

const Bullet = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: ${({ theme }) => theme.palette.grayscale.white};
  background-color: ${({ theme }) => theme.palette.primary.main};
  width: 20px;
  height: 20px;
  border-radius: 50%;
  padding-bottom: 2px;
  font-size: 0.8rem;
`;

export type BulletListProps = {
  items: ReactNode[];
};

export const OrderedList: FC<BulletListProps> = ({ items }) => {
  return (
    <List>
      {items.map((item, index) => (
        <ListItem key={index}>
          <Bullet>{index + 1}</Bullet>
          <Typography type="body">{item}</Typography>
        </ListItem>
      ))}
    </List>
  );
};
